/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  DeleteApiV1SsoimageIdVideoMutationRequest,
  DeleteApiV1SsoimageIdVideoMutationResponse,
  DeleteApiV1SsoimageIdVideoPathParams,
  DeleteApiV1SsoimageIdVideo400,
  DeleteApiV1SsoimageIdVideo401,
  DeleteApiV1SsoimageIdVideo404,
  DeleteApiV1SsoimageIdVideo500,
} from "../../types/SSOImageController/DeleteApiV1SsoimageIdVideo.ts";

function getDeleteApiV1SsoimageIdVideoUrl(
  id: DeleteApiV1SsoimageIdVideoPathParams["id"],
) {
  const res = {
    method: "DELETE",
    url: `/api/v1/ssoimage/${id}/video` as const,
  };
  return res;
}

/**
 * @description Remove o arquivo de vídeo do Azure Blob Storage. O blobPath retornado pelo endpoint de upload deve ser informado no corpo da requisição. **(Requer Authorization para autenticação)**
 * @summary Excluir vídeo SSO do storage (Requer Authorization para autenticação)
 * {@link /api/v1/ssoimage/:id/video}
 */
export async function deleteApiV1SsoimageIdVideo(
  id: DeleteApiV1SsoimageIdVideoPathParams["id"],
  data: DeleteApiV1SsoimageIdVideoMutationRequest,
  config: Partial<RequestConfig<DeleteApiV1SsoimageIdVideoMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    DeleteApiV1SsoimageIdVideoMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1SsoimageIdVideo400
      | DeleteApiV1SsoimageIdVideo401
      | DeleteApiV1SsoimageIdVideo404
      | DeleteApiV1SsoimageIdVideo500
    >,
    DeleteApiV1SsoimageIdVideoMutationRequest
  >({
    method: "DELETE",
    url: getDeleteApiV1SsoimageIdVideoUrl(id).url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
